var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-n" }, [
    _c("div", { staticClass: "footer-container" }, [
      _c("div", { staticClass: "footer-top" }, [
        _c("div", { staticClass: "footer-top-left" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "footer-links" }, [
            _c("div", { staticClass: "ft-group" }, [
              _c("div", { staticClass: "footer-nav" }, [
                _c("span", { staticClass: "fn-title" }, [_vm._v("Company")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { "aria-label": "About Us" },
                    on: { click: _vm.toAbout }
                  },
                  [_vm._v(" About Us ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { href: _vm.mv_url + "/blog", "aria-label": "Blog" }
                  },
                  [_vm._v("Blog")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer-nav" }, [
                _c("span", { staticClass: "fn-title" }, [_vm._v("COMMUNITY")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { "aria-label": "For Musicians" },
                    on: { click: _vm.toMusicians }
                  },
                  [_vm._v("\n                For Musicians\n              ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "/#/donation-page",
                      "aria-label": "Missions Project"
                    }
                  },
                  [_vm._v("Missions Project\n              ")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ft-group" }, [
              _c("div", { staticClass: "footer-nav" }, [
                _c("span", { staticClass: "fn-title" }, [_vm._v("RESOURCE")]),
                _vm._v(" "),
                _c(
                  "a",
                  { attrs: { href: "/#/premium", "aria-label": "Premium" } },
                  [_vm._v("\n                Premium\n              ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { href: _vm.playerUrl, "aria-label": "Web Player" }
                  },
                  [_vm._v("Web Player")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { href: "/#/mobile-app", "aria-label": "Mobile App" }
                  },
                  [_vm._v("Mobile App")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer-nav" }, [
                _c("span", { staticClass: "fn-title" }, [_vm._v("Help")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.mv_url + "/terms-and-conditions",
                      "aria-label": "Terms of Use"
                    }
                  },
                  [_vm._v("Terms of Use\n              ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.mv_url + "/privacy-policy",
                      "aria-label": "Privacy Policy"
                    }
                  },
                  [_vm._v("Privacy Policy\n              ")]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer-top-right" }, [
          _c("span", { staticClass: "subs-title" }, [
            _vm._v("Subscribe to Our Newsletter")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "subs-desc" }, [
            _vm._v(
              "\n          Subscribe to our newsletter to get the latest promo, release\n          updates, and missions project!\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subs-form" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.email_subscribe,
                  expression: "form.email_subscribe"
                }
              ],
              attrs: {
                type: "text",
                placeholder: "Email",
                disabled: _vm.isSending
              },
              domProps: { value: _vm.form.email_subscribe },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "email_subscribe", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-n primary",
                attrs: {
                  type: "button",
                  id: "mc-embedded-subscribe",
                  disabled: _vm.isSending || _vm.form.email_subscribe === ""
                },
                on: { click: _vm.onSubmitJoin }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.isSending ? "Sending..." : "Subscribe") +
                    "\n          "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(1)
    ]),
    _vm._v(" "),
    _vm.showToast
      ? _c("div", { staticClass: "toastr" }, [
          _c("div", { staticClass: "toastr-container" }, [
            _c("div", { staticClass: "toastr-body" }, [
              _c("img", {
                attrs: {
                  src:
                    _vm.toastType === "success"
                      ? _vm.successIcon
                      : _vm.errorIcon
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "toastr-content" }, [
                _vm._v("\n          " + _vm._s(_vm.toastMsg) + "\n        ")
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "toastr-close",
                attrs: { type: "button", "aria-label": "close" },
                on: {
                  click: function($event) {
                    _vm.showToast = false
                  }
                }
              },
              [_vm._v("x")]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/logo-blue.svg"),
          alt: "MusicVerse Logo"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-bottom" }, [
      _c("div", { staticClass: "footer-nav footer-nav-social" }, [
        _c("span", { staticClass: "fn-title" }, [_vm._v("CONNECT WITH US")]),
        _vm._v(" "),
        _c("div", { staticClass: "fn-socials" }, [
          _c(
            "a",
            {
              attrs: {
                href: "mailto:info@musicverse.org",
                "aria-label": "Mail"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/mail-icon-n.svg"),
                  alt: "icon mail"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://www.instagram.com/musicverseinternational/?hl=en",
                "aria-label": "Instagram"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/instagram-icon.svg"),
                  alt: "ig icon"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.facebook.com/musicverse.org",
                "aria-label": "Facebook"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/fb-icon-n.svg"),
                  alt: "fb icon"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://twitter.com/MusicVerseIntl",
                "aria-label": "Twitter"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/twitter-icon.svg"),
                  alt: "twitter icon"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://www.youtube.com/channel/UCjRCshDsxtam7Wh9SIKLuHA",
                "aria-label": "Youtube"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/youtube-icon.svg"),
                  alt: "youtube icon"
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("©MusicVerse. 2023. All rights reserved.")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3edc398", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3edc398","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterLandingNew.vue
// module id = null
// module chunks = 